import index from "@/pages/company/baseinfo/Index"
import edit from "@/pages/company/baseinfo/Edit"
import editOther from "@/pages/company/baseinfo/EditOther"
import route from "@/components/router/Router"

export default {
    path : "company-base-info",
    name : "company-base-info",
    meta : {
        title : "单位基本资料",
    },
    redirect : {
        name : "companyinfo",
    },
    component: route,
    children : [
        {
            path: 'companyinfo',
            name: 'companyinfo',
            meta: {
                title: '单位基本资料-单位管理'
            },
            component: index,
        },
        {
            path: 'editcompany',
            name: 'editcompany',
            meta: {
                title: '编辑单位基本资料-单位管理'
            },
            component: edit
        },
        {
            path: 'edit-other-company',
            name: 'edit-other-company',
            meta: {
                title: '编辑单位基本资料-单位管理'
            },
            component: editOther
        }
    ]
}







// WEBPACK FOOTER //
// ./src/router/company/baseinfo/index.js